<div class="title">
  <div class="icon">
    @if (itemForm.customIcon) {
      <app-custom-icon [customIcon]="itemForm.customIcon.icon"></app-custom-icon>
    }
  </div>
  <h3>
    {{category}}
  </h3>
</div>
<div class="content">
  <table mat-table [dataSource]="dataSource">

    <!-- Item column -->
    <ng-container matColumnDef="name">
      <th class="header-with-border" mat-header-cell *matHeaderCellDef>Items</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <div class="item-column">
          <!-- Remove or check button -->
          @if (itemForm.itemCategory === itemCategory.MOBILITY || itemForm.itemCategory === itemCategory.PLACE) {
            @if (row.controls.name.defaultValue != '' && row.controls.custom.defaultValue === false) {
              <mat-checkbox
                [formControl]="row.controls.active"
                [ngClass]="this.itemForm.customIcon?.class">
              </mat-checkbox>
            } @else {
              <div class="circle" (click)="removeInput(i)">
                <mat-icon class="circle-icon" aria-hidden="false" aria-label="Rij verwijderen" fontIcon="delete"></mat-icon>
              </div>
            }
          }

          <!-- Label or inputfield for item -->
          @if (row.controls.name.defaultValue != ''  && row.controls.custom.defaultValue === false) {
            <span>
              {{row.controls.name.defaultValue}}
            </span>
          } @else {
            <mat-form-field class="fit-matInput">
              <input matInput [formControl]="row.controls.name">
            </mat-form-field>
          }
        </div>
      </td>
    </ng-container>

    <!-- Verantwoordelijke column -->
    <ng-container matColumnDef="stakeholder">
      <th class="header-with-border" mat-header-cell *matHeaderCellDef>Verantwoordelijke</th>
      <td mat-cell *matCellDef="let row; let i = index">
        <mat-form-field class="full-width">
          <mat-select
            [formControl]="row.controls.stakeholder"
            role="listbox"
            aria-label="Naam opties"
            >
            @for (stakeholder of stakeholders(); track stakeholder) {
              <mat-option [value]="stakeholder.userId">{{stakeholder.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="row" mat-row *matRowDef="let row; index as i; columns: displayedColumns;"></tr>
  </table>
  @if (addInputAllowed()) {
    <button mat-button color="primary" (click)="addInput()">+ Item toevoegen</button>
  }
</div>
